import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpEventType, HttpRequest, HttpErrorResponse, HttpEvent } from '@angular/common/http';
import { environment1 } from '../../environments/environment.prod';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class UserService {
	private subject = new Subject<any>();
	addParam = 'cosmos'
	constructor(private httpClient: HttpClient) { }
	httpOptions = {
		headers: new HttpHeaders({
			// 'Content-Type': 'application/json'
		})
	}



	sendProductId(id: any) {
		this.subject.next(id);
	}
	getProductId(): Observable<any> {
		return this.subject.asObservable();
	}
	specialProducts(page): Observable<any> {
		return this.httpClient.post<any>(environment1.commonEndPoint + "specialproductlistquartz?page=" + page + '&website=' + this.addParam, {}, this.httpOptions)
			.pipe(retry(1))
	}
	autoSuggestspecialProducts(name, isnew): Observable<any> {
		return this.httpClient.post<any>(environment1.commonEndPoint + "getautosuggestionspecialproductlistquartz?name=" + name, {}, this.httpOptions)
			.pipe(retry(1))
	}
	specialproductdetailquartz(id): Observable<any> {
		return this.httpClient.post<any>(environment1.commonEndPoint + "specialproductdetailquartz?slug=" + id + '&website=' + this.addParam, {}, this.httpOptions)
			.pipe(retry(1))
	}
	colorListing(): Observable<any> {
		return this.httpClient.post<any>(environment1.commonEndPoint + "specialProductColorListQuartz", {}, this.httpOptions)
			.pipe(retry(1))
	}

	selectColor(data): Observable<any> {
		return this.httpClient.post<any>(environment1.commonEndPoint + 'getColorListQuartz', JSON.stringify(data), this.httpOptions)
			.pipe(retry(1))
	}
	allLocationDetails(): Observable<any> {
		return this.httpClient.post<any>(environment1.endPoint + "allLocationDetails", {}, this.httpOptions)
			.pipe(retry(1))
	}
	allLocation(): Observable<any> {
		return this.httpClient.post<any>(environment1.endPoint + "allLocation", {}, this.httpOptions)
			.pipe(retry(1))
	}

	filterProduct(data): Observable<any> {
		return this.httpClient.post<any>(environment1.commonEndPoint + 'getSpecialProductFilter', data, this.httpOptions)
			.pipe(retry(1))
	}

	specialproductlistquartz(): Observable<any> {
		return this.httpClient.post<any>(environment1.commonEndPoint + 'specialproductlistquartz' + '?page=6' + '&website=' + this.addParam, {}, this.httpOptions)
			.pipe(retry(1))
	}
	getAllFilter(): Observable<any> {
		return this.httpClient.post<any>(environment1.commonEndPoint + "getAllFilter" + '?website=' + this.addParam, {}, this.httpOptions)
			.pipe(retry(1))
	}

	getintouch(data): Observable<any> {
		return this.httpClient.post<any>(environment1.endPoint + 'contact-store-quartz', data, this.httpOptions)
			.pipe(retry(1))
	}
	ordersample(data): Observable<any> {
		return this.httpClient.post<any>(environment1.endPoint + 'ordersample-quartz', data, this.httpOptions)
			.pipe(retry(1))
	}
	bookAppointment(data): Observable<any> {
		return this.httpClient.post<any>(environment1.endPoint + 'appoinment-submission-quartz', data, this.httpOptions)
			.pipe(retry(1))
	}
	// addHero(hero): Observable<any> {
	// 	return this.httpClient.post<any>(environment1.endPoint, hero, this.httpOptions)
	// 	  .pipe(
	// 		catchError(this.handleError('addHero', hero))
	// 	  );
	//   }

	//https://staging.cosmosgranite.com/api/allLocationDetails
	//https://staging.cosmosgranite.com/api/specialproductlistquartz
	//https://staging.cosmosgranite.com/api/specialproductlistquartz?page=6&website=igm
	//https://staging.cosmosgranite.com/api/ordersample
}
